export { GlobalStyles } from "./global-styles";
import { useContext } from "react";
import { ThemeContext } from "styled-components";
import theme from "./theme";

const useTheme = () => useContext(ThemeContext);

export { theme, useTheme };
